import React from 'react';
import { OPERATION_TYPE, operationType, supportSteps } from "../../../../util/varibles/constants";
import { durationTxtByStartAndFinish } from "../../../../util/varibles/global";
import { IOperation2, ISupportOp2 } from "../../../../util/varibles/interface";
import Checklists from "../../_components/Checklists";
import Operation from "../../_components/Operation";
import stylesOp from "../../_components/Operation/style.module.scss";
import OperationTime from "../../_components/OperationTime";
import Vessel from "../../_components/Vessel";
import ViewNote from "../../_components/ViewNote";
import WrapperActivityLog from "../../_components/WrapperActivityLog";

interface IProps {
    data: IOperation2<ISupportOp2>
    isOwn: boolean
}

const Support: React.FC<IProps> = ({ data, isOwn }) => {
    const { note = '' } = data.operation;

    const { activity_log } = data
    const est_start_time = activity_log[0].est_start_time;
    const est_finish_time = activity_log[activity_log.length - 1].est_start_time;

    const activityLog = activity_log.map((item: any, index: number) => ({
        list: [{ ...item, steps: [supportSteps[index]], index }],
    }))

    return <div className='col-span-2 pb-3'>
            <div className='grid grid-cols-1 items-stretch gap-[15px] min-[901px]:grid-cols-[minmax(0,2fr)_minmax(290px,1fr)] mb-[15px]'>
                <div className='min-w-0 [&>div]:!mb-0 [&>div]:!h-full [&>div]:w-full'>
                    <Operation {...{ isNote: note.length === 0 }}>
                <div className={stylesOp['info-line']}>
                    <span>Operation type: </span>
                    <span>{operationType[OPERATION_TYPE.SUPPORT].name}</span>
                </div>
                <OperationTime activity_log={activity_log} />
                <div className={stylesOp['info-line']}>
                    <span>Planned duration: </span>
                    <span>{durationTxtByStartAndFinish(est_start_time, est_finish_time)}</span>
                </div>
                <ViewNote data={data} isOwn={isOwn} note={note} />
                    </Operation>
                </div>
                <div className='min-w-0 [&>div]:!mb-0 [&>div]:!h-full [&>div]:w-full'>
                    <Checklists />
                </div>
            </div>
            <div className='grid grid-cols-1 items-stretch gap-[15px] min-[901px]:grid-cols-[minmax(0,2fr)_minmax(290px,1fr)] mb-[15px]'>
                <div className='min-w-0 [&>div]:!mb-0 [&>div]:!h-full [&>div]:w-full'>
                    <Vessel />
                </div>
                <div className='min-w-0 [&>div]:!mb-0 [&>div]:!h-full [&>div]:w-full'>
                    <WrapperActivityLog
                        isOwn={isOwn}
                        data={data}
                        activity_log={activityLog}
                        activity_log_root={activity_log}
                    />
                </div>
            </div>
    </div>
};

export default Support;
